import { createStore, applyMiddleware } from "redux";
import { loggerMiddleware, multi, thunk } from "./middlewares";
import rootReducer from "./reducers";
import userManager from "@utils/userManager";

import { composeWithDevToolsDevelopmentOnly as composeWithDevTools } from "@redux-devtools/extension";

import { UserState, loadUser } from "redux-oidc";
import { IBiometry } from "./reducers";

export interface IStoreState {
  biometrics: IBiometry;
  oidc: UserState;
  beneficiario: any;
  exame: any;
  prestador: any;
}

const INITIAL_STATE = {};

const store = createStore(
  rootReducer,
  INITIAL_STATE,
  composeWithDevTools(
    /* logger must be the last middleware in chain to log actions */
    applyMiddleware(thunk, multi, loggerMiddleware)
  )
);

loadUser(store, userManager);

export default store;
